/**
 * WOXCKER 补丁：语言/国家选择器（localization-form）交互脚本
 * 主题 beyours691 的 header 渲染了 <localization-form> 但 global.js 未实现该自定义元素，
 * 导致语言下拉点不开、切换无效。此脚本补全标准行为。
 */
(function () {
  if (window.WXCKER_LOCALIZATION_READY) return;
  window.WXCKER_LOCALIZATION_READY = true;

  function initForms() {
    document.querySelectorAll('localization-form').forEach(function (el) {
      if (el.__wxcLocalization) return;
      el.__wxcLocalization = true;

      var input = el.querySelector('input[name="locale_code"], input[name="country_code"]');
      var button = el.querySelector('.disclosure__button, button[aria-controls]');
      var panel = el.querySelector('.disclosure__list, ul[role="list"]');
      var form = el.querySelector('form');

      if (!input || !button || !panel || !form) return;

      // 展开 / 收起
      button.addEventListener('click', function () {
        var hidden = panel.hasAttribute('hidden');
        if (hidden) {
          panel.removeAttribute('hidden');
          button.setAttribute('aria-expanded', 'true');
        } else {
          panel.setAttribute('hidden', '');
          button.setAttribute('aria-expanded', 'false');
        }
      });

      // 点击语言/国家项 → 写入 input 并提交表单
      el.querySelectorAll('a[data-value]').forEach(function (a) {
        a.addEventListener('click', function (e) {
          e.preventDefault();
          input.value = a.getAttribute('data-value');
          form.submit();
        });
      });

      // ESC 关闭
      el.addEventListener('keyup', function (e) {
        if (e.key === 'Escape' || e.key === 'Esc') {
          panel.setAttribute('hidden', '');
          button.setAttribute('aria-expanded', 'false');
          button.focus();
        }
      });

      // 点击外部关闭
      document.addEventListener('click', function (e) {
        if (!el.contains(e.target)) {
          panel.setAttribute('hidden', '');
          button.setAttribute('aria-expanded', 'false');
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initForms);
  } else {
    initForms();
  }
})();
